module.exports = __webpack_public_path__ + "img/wa-bg-dark.0e16b852.jpg";